import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { GoogleService } from '../../services/google/google.service';
import { IcecontrolSettings } from '../../components/models/icesettings';

@Component({
  selector: 'icerecaptcha',
  templateUrl: './icerecaptcha.component.html',
  styleUrls: ['./icerecaptcha.component.scss']
})
export class IcerecaptchaComponent implements OnInit {
  // Input Members
  @Input() ctrl: IcecontrolSettings = null;

  // View Child
  @ViewChild('recaptcha') recaptchaElement: ElementRef;

  constructor(private googleService: GoogleService) {
  }

  ngOnInit() {
    this.googleService.initializeRecaptchaScript(this.recaptchaElement);
  }

}
